import { createServerFn } from '@tanstack/react-start'
import { getFromS3, putToS3 } from '../../lib/s3'
import { updateNoteSchema } from './noteSchemas'
import type { Note } from './noteSchemas'

export const updateNote = createServerFn({ method: 'POST' })
  .inputValidator(updateNoteSchema)
  .handler(async (ctx): Promise<{ success: boolean }> => {
    const { noteId, title, segments, lastEditedBy } = ctx.data
    const existing: Note = await getFromS3(`notes/${noteId}.json`)
    const updated: Note = {
      ...existing,
      title: title.trim() || 'Untitled',
      segments,
      lastEditedBy,
      updatedAt: new Date().toISOString(),
    }
    await putToS3(`notes/${noteId}.json`, updated)
    return { success: true }
  })
